import { render, staticRenderFns } from "./taskTags.vue?vue&type=template&id=d094882e&"
import script from "./taskTags.vue?vue&type=script&lang=js&"
export * from "./taskTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports